module.exports = __webpack_public_path__ + "static/media/boton-agregarusuario.803ad591.svg";